<template lang="pug">
md-layout(md-column)
  md-theme(md-name='blue')
    // Title
    breadcrumbs(section='Videos', :nav='nav')
    router-link(:to='{ name: "CreateVideo" }')
      md-button#btn-add-mediaitem.md-fab.md-fab-bottom-right.md-icon-button
        md-icon(md-iconset="fa fa-plus")
    media-item-table.content-table
</template>

<script>
  import MediaItemTable from '../../shared-components/mediaItem/MediaItemTable';
  import Breadcrumbs from '../../shared-components/Breadcrumbs';

  export default {
    components: {
      MediaItemTable,
      Breadcrumbs
    },
    computed: {
      nav() {
        return [
          { title: 'Videos' }
        ]
      },
    }
  };
</script>

<style lang="scss" scoped>
  .on-left {
    margin-top: -5px;
    margin-right: 5px;
  }
  .content-table {
    margin: 25px 10%;
    @media (max-width: 945px) {
      margin-left: 5px;
      margin-right: 5px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/spa/mediaItem/MediaItemList.vue